import React from 'react';
import { useNavigate } from 'react-router-dom';

import CartButton from './CartButton';
import classes from './Header.module.css';
import Logo from '../../assets/logo_2.png';
import HeaderBg from '../../assets/header_bg.jpeg';

const Header = ({ onShowCart }) => {
  const navigate = useNavigate();

  return (
    <>
      <header className={`${classes.header} justify-content-start`}>
        <img src={Logo} width={70} />
        <CartButton onClick={() => navigate('/order')} />
      </header>
      <div className={classes['main-image']}></div>
    </>
  );
};

export default Header;
